import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  Menu,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  CircularProgress,
  Tooltip
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from 'src/redux/store.js';
import { getUserList, deleteUser } from 'src/redux/slices/user.js';
// import { UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';

// routes
// components
import Page from 'src/components/Page.js';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Label from 'src/components/Label.js'; 
import Scrollbar from 'src/components/Scrollbar.js';
import SearchNotFound from 'src/components/SearchNotFound.js';
import { UserListHead, UserListToolbar, UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';
import  ProjectListViewToolbar  from 'src/components/_dashboard/user/list/ProjectListViewToolbar';
import  ProjectListMenu  from 'src/components/_dashboard/user/list/ProjectListMenu';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { COMPANY_LOGO, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import LoadingScreen from 'src/components/LoadingScreen';
import FullScreenDialogsAllJobs from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogsAllJobs';
import quickbookLogo from '../../assets/quickbookLogo-removebg-preview.png'

import { Form, Formik, FormikProvider } from 'formik';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { empty } from 'src/Helpers/Common';
import moment from 'moment/moment';


// ----------------------------------------------------------------------

  const option = [
    { id: 0, value: 'Inactive' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Open' },
    { id: 3, value: 'Completed' },
    { id: 4, value: 'Hold' },
    { id: 5, value: 'Accepted' },
    { id: 6, value: 'Rejected' },
    { id: 7, value: 'Verified' },
    { id: 6, value: 'Reopen' },
  ]

  const colors = [
    'error',
    'primary',
    'secondary',
    'success',
    'warning',
    'success',
    'error',
    'success',
    'error',
  ]
  
  
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const onboard_data=[
    {
        id:0,
        status:'Pending',
        name:'Laffety',
        number:'123456789',
        address:'California',
        total:'23925.00 USD',
        createdon:'12/31/1969',
    },
    {
        id:1,
        status:'Pending',
        name:'K Hovnanian',
        number:'6532611678',
        address:'Manteca',
        total:'11990.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:2,
        status:'Pending',
        name:'Chase Brendle',
        number:'1215165265',
        address:'San Francisco',
        total:'24480.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:3,
        status:'Pending',
        name:'Jane Doe',
        number:'281728173',
        address:'Sedona',
        total:'68206.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:4,
        status:'Pending',
        name:'Adam Sandler',
        number:'3152614141',
        address:'Miami',
        total:'14280.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:5,
        status:'Pending',
        name:'Umila Garib',
        number:'2728738268',
        address:'West Palm Beach',
        total:'11990.00 USD',
        createdon:'12/31/1969',

    },
]


  const getStatusColorAndLabelQuickbid = (status, quotation) => {
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' }
      case 2:
        return { color: 'info', label: 'Open' }
      case 3:
        return { color: 'primary', label: 'Evaluating' }
      case 4:
        return {
          color: quotation == 0 ? 'default' : 'success',
          label: quotation == 0 ? 'Archive' : 'Approved',
        }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelForProposal = (status) => {
    switch (status) {
      case 1:
        return { color: 'info', label: 'Open' }
      case 2:
        return { color: 'warning', label: 'Awarded' }
      case 3:
        return { color: 'error', label: 'Rejected' }
      case 4:
        return { color: 'success', label: 'Approved' }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      case 7:
        return { color: 'success', label: 'Paid' }
      default:
        return { color: 'info', label: 'Open' }
    }
  }
export default function   DesignOrderList({projectData, noImage,
    accept_status,
    currentTab,
    designOrder,
    estimate,
    salesOrder,
    CommunityJob,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    fromClient,
    setRenderCards,
    renderCards,
    handleOpenDetails,
    handleOpenViewEstimate,
    CommunityProjects,
    quotationView,
    proposalView,
    communityDesignOrder,
    handleOpenViewSalesOrder ,
    handleOpenDetailsSalesOrder,
    handleOpenViewPurchaseOrder,
    handleOpenDetailsPurchaseOrder,
    installsJobs,
    cinstalls,
    isDesign,
    handleOpenViewDesignOrder,
    handleOpenDetailsDesignOrder
}) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const UsersListV = onboard_data; // Replaced UsersListV with onboard_data
//   const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  const { enqueueSnackbar } = useSnackbar();
  const navigate=useNavigate()
  const [isDelete,setIsDelete] = useState(false)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [deleteId,setDeleteId] = useState(null);
   const [deleteTeam, setDeleteTeam] = useState(false);
     const [anchorEl, setAnchorEl] = useState(null);
     const [setectedRow, setSelectedRow] = useState(null);
       const [holdReason, setHoldReason] = useState('');
       const [isSubmittingHold, setIsSubmittingHold] = useState(false);
       const [holdReasonError, setHoldReasonError] = useState('');
     console.log('setectedRow=====================', setectedRow)
  let userData = JSON.parse(localStorage.getItem('user'))
  let userType = userData.user_type
  const explodedPermissions =userData?.exploded_permissions
  const handleClose = () => {
    setAnchorEl(null);
  };
const TABLE_HEAD = [
      { id: 'id', label:  'ID', alignRight: false },
      // { id: '', label:  '', alignRight: false },
    { id: 'name', label:  'Name', alignRight: false },    
     ...(
    estimate && proposalView
      ? [{ id: 'date', label: 'Created', alignRight: false }]
      : estimate && installsJobs
        ? [
            { id: 'project', label: 'Project', alignRight: false },
          ]
      : estimate
        ? [
            { id: 'project', label: 'Project', alignRight: false },
            { id: 'client', label: 'Client', alignRight: false },
          ]
        : []
  ),
      { id: 'status', label: 'Status', alignRight: false },
    ...(userData.user_type === 3
      ? []
      : [{ id: 'options', label: 'Options', alignRight   : false }])
  ];
  const TABLE_HEAD2 = [
      { id: 'id', label:  'ID', alignRight: false },
      // { id: '', label:  '', alignRight: false },
    { id: 'image', label: 'Profile Image', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
      ...(
    estimate && proposalView
      ? [{ id: 'date', label: 'Created', alignRight: false }]
      : estimate
        ? [
            { id: 'project', label: 'Project', alignRight: false },
          ]
        : []
  ),
     
    { id: 'status', label: 'Status', alignRight: false },
    ...(userData.user_type === 3
      ? []
      : [{ id: 'options', label: 'Options', alignRight: false }])  
 
  ];
    const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 1:
      return { 
        color: 'primary',
        //  label: 'Status: Open'
         label: ' Open'
         }
    default:
      return { color: 'default', label: 'Pending' }
  }
}

  const getStatusColorAndLabelSales = (
    status,
    installationStatus,
    allInstallationCompleted,
    accepted,
    min_payment_status,
    billing_type,
    noServiceNoTask,
    proj_status,
    job_category_name,
    CompletedStatus,
    row
  ) => {
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' }
      case 2:
        return { color:row?.hold == 1 ? 'warning' : 'info', label: row?.hold == 1 ? 'Hold' : 'Open'}
      case 3:
        return {
          color: `${
            row?.hold === 1 ? 'warning':
            row?.project_category == 13
              ? 'primary'
              : min_payment_status == 0
              ? 'warning'
              : 'primary'
          }`,
          label: `${
            row?.hold === 1 ? 'Hold' :
            row?.project_category == 13 || billing_type == 0
              ? 'Approved'
              : min_payment_status == 1
              ? 'Approved and Paid'
              : 'Approved and Payment Due'
          }`,
        }
      // return { color: `${min_payment_status==0? 'warning' :'primary'}`, label: `${min_payment_status==1? 'Approved and Paid' :'Approved & Awaiting for Payment'}` }
      case 4:
        // return { color: 'success', label: !empty(allInstallationCompleted) ? 'Completed' : (!empty(installationStatus) ? 'Installation' : 'In Production') }
        return {
          color: (noServiceNoTask == 1 && proj_status == 3) ? 'success' :
            empty(accepted) && !empty(allInstallationCompleted)
              ? 'warning'
              : 'success',
          label: (noServiceNoTask == 1 && proj_status == 3) ? 'No Service No Task' :
            empty(accepted) && (!empty(allInstallationCompleted))
              ? `${CompletedStatus} Completed & Awaiting approval`
              : (job_category_name === 'Build Order' && status === 4 && accepted === 1) ? 'Completed'
              : !empty(accepted) && (!empty(allInstallationCompleted))
              ? `${CompletedStatus} Completed & Approved`
              : !empty(installationStatus)
              ? `${CompletedStatus}`
              : CommunityJob ? `${CompletedStatus} Completed & Approved` : `In-Production`,
        } // return { color: 'primary', label: 'Converted to Job' };
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
         case 10:
        return { color: 'success', label: 'Completed -No Service No Task' }
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelDesignOrder = (status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_in_queue) => {
    // HOLD: hold=1 AND status !=0
    if (hold == 1 && status != 0) {
      return {
        color: 'warning',
        label: 'Hold',
      }
    }
    
    // REJECTED: status=6 AND hold=0
    if (status == 6 && hold == 0) {
      return {
        color: 'error',
        label: 'Rejected',
      }
    }
    
    // APPROVED: status=2 AND hold=0
    if (status == 2 && hold == 0) {
      return {
        color: 'success',
        label: 'Approved',
      }
    }
    
    // DESIGN JOB COMPLETED: design_order_job_status = 3 AND send_client_app_req=0 AND status !=0 AND hold = 0
    if (design_order_job_status == 3 && send_client_app_req == 0 && status != 0 && hold == 0) {
      return {
        color: 'success',
        label: 'Design Job Completed',
      }
    }
    
    // Check if there are design attachments (doa.id IS NOT NULL equivalent)
    const hasDesignAttachments = attachment_count > 0 || (attachment && Array.isArray(attachment) && attachment.length > 0 && attachment.some(att => att?.isDesign == 1));
    
    // For status 1, check conditions in priority order
    if (status == 1 && hold == 0) {
      // AWAITING APPROVAL: status=1 AND hold=0 AND send_client_app_req=1 AND doa.id IS NOT NULL
      if (send_client_app_req == 1 && hasDesignAttachments) {
        return {
          color: 'warning',
          label: 'Awaiting Approval',
        }
      }
      
      // IN DESIGN: doa.id IS NOT NULL AND status = 1 AND hold = 0 AND send_client_app_req=0 AND design_order_job_status != 3
      // if (send_client_app_req == 0 && design_order_job_status != 3 && hasDesignAttachments) {
      if (send_client_app_req == 0 && design_order_job_status == 2) {
        return {
          color: 'info',
          label: 'In Design',
        }
      }
      
      // NEW: status=1 AND hold=0 AND doa.id IS NULL AND design_order_job_status != 3 AND send_client_app_req=0
      // if (!hasDesignAttachments && design_order_job_status != 3 && send_client_app_req == 0) {
      if (send_client_app_req == 0 && design_order_job_status == 1 && is_in_queue == 1) {
        return {
          color: 'info',
          label: 'In Queue',
        }
      }
      if (send_client_app_req == 0 && design_order_job_status == 1 && is_in_queue == 0) {
        return {
          color: 'info',
          label: 'New',
        }
      }
      
      // Default fallback for status 1
      return {
        color: 'info',
        label: 'Open',
      }
    }
    
    // Other status cases
    switch (status) {
      case 3:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Hold' : 'Approved',
        }
      case 4:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Draft',
        }
      case 5:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Closed',
        }
      default:
        return {
          color: hold == 1 ? 'warning' : 'default',
          label: hold == 1 ? 'Hold' : 'Open',
        }
    }
  }

  const handleUpdateSalesOrderHoldStatus = async (reason,id) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}sales_order/update-sales-order-hold-status`,
        {
          request_id: Number(id),
          userId: user.user_id,   
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };
    const handleUpdateHoldStatus = async (reason,id) => {
      try {
        const user = JSON.parse(window.localStorage.getItem('user'));
        const res = await axios.post(
          `${REST_API_END_POINT}project/update-design-order-job-hold-status`,
          {
            projectId: Number(id),
            userId: user.user_id,
            reason: reason || '',
          },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );
        if (res.data.status === 1) {
          enqueueSnackbar(res.data.message, { variant: 'success' });
          setRenderCards(!renderCards);
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
      } catch (error) {
        console.error('Error updating hold status:', error);
      }
    };

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  // Rest of the code remains unchanged from here
  // ...
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = UsersListV.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };


  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const emptyRows = projectData.length > 0 ? 0 : 2;
  
  const isUserNotFound = projectData?.length === 0;
  const handleClickOpenViewPage=(id,name)=>{
    setProjectId(id)
    setProjectName(name)
    setOpenViewPage(true)
    localStorage.setItem("openProductionPopup", "true");
    localStorage.setItem("projectId", id);
    localStorage.setItem("projectName", name);
    
    // setSearchParams({
    //   open: "true",
    //   // view: "viewPage",
    //   // projectId: id,
    //   // projectName: name,
    // });
  }
  const changeStatus = async (teamId, teamStatus) => {
    try {
      let status = teamStatus;
      let userId = userData.user_id
    
      let response = await axios.post(`${REST_API_END_POINT}teams/delete-team-members`,
        { teamId, status, userId },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        })
    
      if (response.data.status === 1) {
        setDeleteId('');
        enqueueSnackbar(response.data.message, { variant: 'success' });
        navigate(PATH_DASHBOARD.callCenter.teams, { state: { data: teamId } });
      }
      else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      else {
       
        enqueueSnackbar("Error.........!", { variant: 'error' });
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }
   const handleDeleteClient=async(id,status)=>{
     try {
      const data={id:id,status:status}
      const res = await axios.post(`${REST_API_END_POINT}clients/remove-client`,data)
      console.log(res.data)
       if(res.data.status ==1){
        setDeleteId('');
        setDeleteTeam(false);
        setRefreshClient((prev)=>!prev)
       enqueueSnackbar(res.data.message,{variant:'success'})
       }else if(res.data.status ==0){
        setDeleteId('');
        enqueueSnackbar(res.data.message,{variant:'error'})
       }
     } catch (error) {
       console.log(error,'Error in deleting client')
     }
   }
const canViewQuotation = (row) => {
  if (row?.quotation_status === 6) return false;
  if (userType === 3 && row?.accept_status === 2) return false;

  if ((row?.quotation_status === 4 && row?.quotation === 0) || userType === 3) {
    return (
      explodedPermissions?.some((permission) =>
        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
      ) || (userType === 3 && row?.status !== 6)
    );
  } else {
    return (
      explodedPermissions?.some((permission) =>
        ['Edit Estimate'].includes(permission)
      ) || (userType === 3 && row?.status !== 6)
    );
  }
};

const canEditQuotation = (row) => {
  return (
    row?.quotation_status !== 6 &&
    (
      explodedPermissions?.some((permission) =>
        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
      ) || (userType === 3 && row?.status !== 6)
    ) &&
    !(userType === 3 && row?.accept_status === 2)
  );
};
const handleQuotationNameClick = (row) => {
  if (!canViewQuotation(row)) {
    enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
    return;
  }
  if ((row?.quotation_status === 4 && row?.quotation === 0) || userType === 3) {
    handleOpenDetails(row?.id, row?.name);
  } else {
    handleOpenViewEstimate(row?.id, row?.name);
  }
};

const handleQuotationEditClick = (row) => {
  if (canEditQuotation(row)) {
    handleOpenDetails(row?.id, row?.name);
  } else {
    enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
  }
};






  return (
<>
      <Grid container spacing={3}>
     
          <Grid item xs={12}>
            <Card>
              {/* <ProjectListViewToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}
  
              <Scrollbar>
                <TableContainer 
                  sx={{ 
                    minWidth: 800, 
                    whiteSpace: "nowrap", 
                    overflowX: "auto",
                    maxHeight: "500px",  // Set a max height to allow scrolling
                    overflowY: "auto",  // Enable vertical scrollbar
                    '&::-webkit-scrollbar': {
                      width: '0.6em',
                      height: '0.6em',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#1e1e1e', // dark background to blend with dark UI
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#555', // medium-gray thumb
                      borderRadius: '6px',
                      border: '2px solid #1e1e1e', // contrast border to separate from track
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#888', // lighter on hover for feedback
                    },
                    '&::-webkit-scrollbar-corner': {
                      backgroundColor: '#1e1e1e' // match your dark background
                    },
                  }}
                >
                  <Table 
                    stickyHeader
                    sx={{
                      '& .MuiTableCell-head': {
                       
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        height: '48px',
                        minHeight: '48px',
                        maxHeight: '48px',
                        lineHeight: 1.4,
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                        verticalAlign: 'middle'
                      },
                      '& .MuiTableSortLabel-root': {
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        justifyContent: 'flex-start',
                        '& .MuiTableSortLabel-icon': {
                          marginLeft: '4px'
                        }
                      }
                    }}
                  >
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={noImage ?TABLE_HEAD:TABLE_HEAD2}
                      rowCount={projectData?.length}
                      numSelected={selected?.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                      checkboxPresent={true}
                      
                    />
                  <TableBody>
                    {projectData?.map((row) => {
                      console.log('row===============================', row)
                      const { id, name, accept_status, community_name,participation_ends,installation_start_date,installation_end_date,attachment,customer_pic } = row
                      const status = Number(row?.status)
                      const hold = Number(row?.hold)
                      const filteredAttachments = designOrder
    ? attachment?.filter(imageItem=>(imageItem?.isDesign == 1 && (imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img"))) || []
    : attachment?.filter(imageItem=>(imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img")) || []
                      // let Newimage = COMPANY_LOGO
                      let Newimage = filteredAttachments?.[0]?.name
                                      ? filteredAttachments[0].name
                                      : customer_pic && customer_pic !== 'avatar.jpg'
                                      ? customer_pic
                                      : COMPANY_LOGO
                      const Newname = row?.name;
                      let CompletedStatus =
                        row?.installationCompleteStatus == 1
                          ? 'Installs'
                          : row?.installationCompleteStatus == 2
                            ? 'Pick up'
                            : CommunityJob
                              ? 'Installs'
                              : row?.installationCompleteStatus == 3
                                ? 'Shipping'
                                : ''
                      return (
                        <TableRow
                          hover
                          key={0}
                          sx={{
                            '& .MuiTableCell-root': {
                              padding: '8px 12px',
                              fontSize: '0.75rem',
                              height: 'auto',
                              lineHeight: 1.4
                            }
                          }}
                        >
                          {/* <TableCell padding="checkbox">
                              <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} />
                            </TableCell> */}

                          {/* <TableCell align="right">
                                    <Box sx={{ width: '100%', display: "flex", justifyContent: "center", height: "30px",width:"50px", mt: 2 }}>
                                        {
                                            row?.syncWithQuickbooks ?
                                                <img src={quickbookLogo} width={"50px"} height={"30px"} />
                                                : ""
                                        }
                                    </Box>
                                </TableCell> */}
                          <TableCell align="center">
                            {/* #{row?.id} */}
                            {
                              isDesign ?
                              <Typography sx={{ fontSize: '0.75rem', color: "#90EE90" }}>
                                {row?.id ? `#${row?.id}` : ''}
                              </Typography>
                              :
                            (row?.installation_acceptance && row?.est_doc_number) && (row?.doc_number !== row?.est_doc_number) ?
                              <>
                                <Typography sx={{ fontSize: '0.75rem', color: "#90EE90" }}>
                                  {row?.est_doc_number ? `Job: #${row?.est_doc_number}` : ''}
                                </Typography>
                                <Typography sx={{ fontSize: '0.75rem', color: "#90EE90" }}>
                                  {row?.doc_number ? `Inv: #${row?.doc_number}` : ''}
                                </Typography>
                              </>
                              :
                              <Typography sx={{ fontSize: '0.75rem', color: "#90EE90" }}>
                                {row?.doc_number ? `#${row?.doc_number}` : ''}
                              </Typography>
                            }
                          </TableCell>
                          {!noImage && !installsJobs &&<TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                            <img
                              src={Newimage || 'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'}
                              style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '5px',
                                margin: '0 auto',
                                display: 'block',
                                objectFit: 'fill',
                              }}
                              alt={Newname}
                            />
                          </TableCell>}
                          {/* <TableCell align="center">{row?.request_id}</TableCell> */}
                          {estimate ?
                            <>
                              {!salesOrder ? <TableCell align="left" sx={{
                                fontSize: '0.75rem',
                                '&:hover': {
                                  cursor: 'pointer',
                                  textDecoration: 'underline',
                                },
                              }}
                                onClick={() => {
                                  handleQuotationNameClick(row)
                                }}
                              >{Newname}
                              </TableCell>
                                :
                                <TableCell align="left" sx={{ fontSize: '0.75rem' }}

                                  onClick={
                                    CommunityProjects
                                      ? explodedPermissions?.some((permission) =>
                                        ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                                      ) || userType == 3
                                        ? () => navigate(PATH_DASHBOARD.project.viewproject + row?.id)
                                        : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                      : quotationView
                                        ? row?.quotation_status != 6
                                          ? ((row?.quotation_status === 4 && row?.quotation === 0) || userType === 3)
                                            ? explodedPermissions?.some((permission) =>
                                              ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                            ) || (userType === 3 && row?.status !== 6)
                                              ? () => handleOpenDetails(row?.id, row?.name)
                                              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                            : explodedPermissions?.some((permission) =>
                                              ['Edit Estimate'].includes(permission)
                                            ) || (userType === 3 && status !== 6)
                                              ? () => handleOpenViewEstimate(row?.id, row?.name)
                                              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                          : () => enqueueSnackbar('Access Denied: Rejected Quotation', { variant: 'error' })
                                        : proposalView
                                          ? row?.proposal_count === 0
                                            ? () => handleOpenViewPurchaseOrder(row?.id, row?.name)
                                            : () => enqueueSnackbar('Access Denied: Proposals Submitted', { variant: 'error' })
                                          : designOrder
                                            ? explodedPermissions?.some((permission) =>
                                              ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                              // ) || (userType === 3 && status !== 6)
                                            ) || (userType === 3)
                                            // ? () => navigate(`/dashboard/design-order/view/${row?.id}`)  
                                            ? () => handleOpenDetailsDesignOrder(row?.id, row?.name)
                                              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                            : explodedPermissions?.some((permission) =>
                                              ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                                            ) || (userType === 3 && row?.status !== 6)
                                              ? userType !== 3
                                              // ? empty(row?.installationStatus)
                                              //     ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${row?.id}`, { state: { fromProjects: true } }) : communityDesignOrder ? navigate(`/dashboard/design-order/view/${row?.id}`) : handleOpenViewSalesOrder(row?.id, row?.name)    
                                              ? empty(row?.installationStatus)
                                                  ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${row?.id}`, { state: { fromProjects: true } }) : communityDesignOrder ? handleOpenDetailsDesignOrder(row?.id, row?.name) : handleOpenViewSalesOrder(row?.id, row?.name)
                                                  : () => enqueueSnackbar('Access Denied: Moved to installation Phase', { variant: 'error' })
                                                : quotationView
                                                  ? explodedPermissions?.some((permission) =>
                                                    ['View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                                  )
                                                    ? () => handleOpenDetails(row?.id, row?.name)
                                                    : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                                  : designOrder
                                                    ? explodedPermissions?.some((permission) =>
                                                      ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                                    )
                                                    // ? () => navigate(`/dashboard/design-order/view/${row?.id}`)  
                                                    ? () => handleOpenDetailsDesignOrder(row?.id, row?.name)
                                                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                                    : proposalView
                                                      ? row?.statusRfp === null || row?.statusRfp === 1
                                                        ? () => handleOpenViewPurchaseOrder(row?.id, row?.name)
                                                        : () => enqueueSnackbar('Access Denied: Proposal submission closed', { variant: 'error' })
                                                        // : () => CommunityJob ? navigate(`/dashboard/official-request/view/${row?.id}`, { state: { fromProjects: true } }) : communityDesignOrder ? navigate(`/dashboard/design-order/view/${row?.id}`) : handleOpenDetailsSalesOrder(row?.id, row?.name)
                                                        : () => CommunityJob ? navigate(`/dashboard/official-request/view/${row?.id}`, { state: { fromProjects: true } }) : communityDesignOrder ? handleOpenDetailsDesignOrder(row?.id, row?.name) : handleOpenDetailsSalesOrder(row?.id, row?.name)
                                              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                  }
                                >
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                    fontSize: '0.75rem',
                                    // mt: 2,
                                    // ml: 2,
                                    // maxWidth: userType != 3 && !CommunityProjects ? 150 : '70%',
                                    cursor: 'pointer',
                                    // display: 'inline-block',
                                    // overflow: 'hidden',
                                    // textOverflow: 'ellipsis',
                                    // whiteSpace: 'nowrap',
                                    // color: theme.palette.primary.main,
                                    '&:hover': {
                                      cursor: CommunityProjects
                                        ? explodedPermissions?.some((permission) =>
                                          ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                                        ) || (userType === 3 && row?.status !== 6)
                                          ? 'pointer'
                                          : 'default'
                                        : quotationView
                                          ? explodedPermissions?.some((permission) =>
                                            ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                          ) || (userType === 3 && row?.status !== 6)
                                            ? 'pointer'
                                            : 'default'
                                          : designOrder
                                            ? explodedPermissions?.some((permission) =>
                                              ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                            ) || (userType === 3 && row?.status !== 6)
                                              ? 'pointer'
                                              : 'default'
                                            : explodedPermissions?.some((permission) =>
                                              ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                                            ) || (userType === 3 && row?.status !== 6)
                                              ? 'pointer'
                                              : 'default',
                                    },
                                  }}
                                >

                                  {Newname}
                                  </Typography>
                                </TableCell>}
                            </>
                            :
                            <TableCell align="left" sx={{
                              fontSize: '0.75rem',
                              '&:hover': {
                                cursor: 'pointer',
                                textDecoration: 'underline',
                              },
                            }}
                              onClick={
                                (explodedPermissions?.some((permission) =>
                                  ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                ) ||
                                  (userType === 3 && status !== 6)) &&
                                  !(userType === 3 && accept_status === 2)
                                  // ? () => navigate(`/dashboard/design-order/view/${row?.id}`)
                                  ? () => handleOpenDetailsDesignOrder(row?.id, row?.name)
                                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                              }
                            >{Newname}
                            </TableCell>}

                          {/* <TableCell align="center">{row?.community_name}</TableCell>
                            <TableCell align="center">{row?.authorized_by}</TableCell>
                            <TableCell align="center">{row?.member_count}</TableCell> */}
                          {/* <TableCell align="center">{row?.city==='DefaultCity' ? '' : row?.city}</TableCell> */}

                          {estimate && proposalView  ?

                            <>
                              <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                  <Label
                                    variant={
                                      theme.palette.mode === 'light' ? 'ghost' : 'filled'
                                    }
                                    color={'default'}
                                  >
                                    {/* <Tooltip title={row?.community_name}> */}
                                      <Typography
                                        variant="subtitle2"
                                        sx={{
                                          fontSize: '0.75rem',
                                          cursor: 'pointer',
                                          display: 'inline-block',
                                          maxWidth: 100, // Adjust as necessary
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        <span
                                          style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {installation_start_date && installation_end_date 
                                            ? `${moment.unix(installation_start_date).format('MM/DD/YYYY')} - ${moment.unix(installation_end_date).format('MM/DD/YYYY')}`
                                            : moment.unix(participation_ends).format('MM/DD/YYYY')
                                          }
                                        </span>
                                      </Typography>
                                    {/* </Tooltip> */}
                                  </Label>                               
                              </TableCell>                              
                            </>
                            : estimate ?
                            <>
                              <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                {community_name ? (
                                  <Label
                                    variant={
                                      theme.palette.mode === 'light' ? 'ghost' : 'filled'
                                    }
                                    color={'warning'}
                                  >
                                    <Tooltip title={row?.community_name}>
                                      <Typography
                                        variant="subtitle2"
                                        sx={{
                                          fontSize: '0.75rem',
                                          cursor: 'pointer',
                                          display: 'inline-block',
                                          maxWidth: 80, // Adjust as necessary
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        <span
                                          style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {community_name}
                                        </span>
                                      </Typography>
                                    </Tooltip>
                                  </Label>
                                ) : (
                                  <Label
                                    variant={
                                      theme.palette.mode === 'light' ? 'ghost' : 'filled'
                                    }
                                    color={'error'}
                                  >
                                    No project
                                  </Label>
                                )}
                              </TableCell>
                              {noImage && !installsJobs &&<TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                <Label
                                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                  color="secondary"
                                >
                                  <Tooltip title={row?.customer_name}>
                                    <Typography
                                      variant="subtitle2"
                                      sx={{
                                        fontSize: '0.75rem',
                                        cursor: 'pointer',
                                        display: 'inline-block',
                                        maxWidth: 150, // Adjust as necessary
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      <span
                                        style={{
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {row?.customer_name}
                                      </span>
                                    </Typography>
                                  </Tooltip>
                                </Label>
                              </TableCell>
                              }

                            </>:null
                          }
                          {estimate && proposalView ?
                          
                          <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Label
                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                color={getStatusColorAndLabelForProposal(
                          userType != 3 ? (row.paymentMode ? 7 : row.awarded ? 2 : 1) : row.paymentMode ? 7 : row.statusRfp,
                        ).color} >
                                {getStatusColorAndLabelForProposal(
                              userType != 3 ? (row.paymentMode? 7:row.awarded ? 2 : 1) : row.paymentMode ? 7 : row.statusRfp,
                            ).label}
                              </Label>
                            </TableCell>
                          
                          :estimate ?
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Label
                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                color={salesOrder ?
                                  getStatusColorAndLabelSales(
                                    row?.status,
                                    row?.installationStatus,
                                    row?.allInstallationCompleted,
                                    row?.installation_acceptance,
                                    row?.min_payment_status,
                                    row?.billing_type,
                                    row?.noServiceNoTask,
                                    row?.proj_status,
                                    row?.job_category_name,
                                    CompletedStatus,
                                    row,
                                  ).color : getStatusColorAndLabelQuickbid(row?.quotation_status, row?.quotation).color} >
                                {salesOrder ?
                                  getStatusColorAndLabelSales(
                                    row?.status,
                                    row?.installationStatus,
                                    row?.allInstallationCompleted,
                                    row?.installation_acceptance,
                                    row?.min_payment_status,
                                    row?.billing_type,
                                    row?.noServiceNoTask,
                                    row?.proj_status,
                                    row?.job_category_name,
                                    CompletedStatus,
                                    row,
                                  ).label : getStatusColorAndLabelQuickbid(row?.quotation_status, row?.quotation).label}
                              </Label>
                            </TableCell>
                            :
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Label
                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                color={getStatusColorAndLabelDesignOrder(status, hold, row?.design_order_job_status, row?.send_client_app_req, row?.attachment_count, attachment, row?.is_in_queue).color} >
                                {getStatusColorAndLabelDesignOrder(status, hold, row?.design_order_job_status, row?.send_client_app_req, row?.attachment_count, attachment, row?.is_in_queue).label}
                              </Label>
                            </TableCell>
                          }
                          {estimate ?
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <>
                                {salesOrder ?
                                  <>
                                    {((userType != 3 && !CommunityProjects) || proposalView) && (
                                      <Button
                                        onClick={
                                          CommunityProjects
                                            ? explodedPermissions?.some((permission) =>
                                              [
                                                'Add Jobs',
                                                'Edit Jobs',
                                                'Activate/Deactivate Jobs',
                                                'Delete Jobs',
                                                'Manage Job Cost',
                                              ].includes(permission),
                                            ) || userType == 3
                                              ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
                                              : () =>
                                                enqueueSnackbar(
                                                  'Access Denied: You do not have sufficient permissions',
                                                  { variant: 'error' },
                                                )
                                            : quotationView
                                              ? (explodedPermissions?.some((permission) =>
                                                ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                              ) ||
                                                (userType === 3 && status !== 6)) &&
                                                !(userType === 3 && accept_status === 2)
                                                ? () => handleOpenDetails(id, name)
                                                : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                              // ? () => handleOpenDetails(id, name)
                                              // ? () => navigate(`/dashboard/quick-bid/view/${id}`)
                                              : designOrder
                                                  ? (explodedPermissions?.some((permission) =>
                                                    ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                                  ) ||
                                                  (userType === 3 && status !== 6)) &&
                                                  !(userType === 3 && accept_status === 2)
                                                  // ? () => navigate(`/dashboard/design-order/view/${id}`)
                                                  ? () => handleOpenDetailsDesignOrder(id, name)
                                                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                                : (explodedPermissions?.some((permission) =>
                                                  [
                                                    'Edit Request',
                                                    'View request',
                                                    'Delete request',
                                                    'Add vendor to request',
                                                    'Add client to request',
                                                  ].includes(permission),
                                                ) ||
                                                  (userType === 3 && status !== 6)) &&
                                                  !(userType === 3 && accept_status === 2)
                                                  ? proposalView
                                                    ? () => handleOpenDetailsPurchaseOrder(id, name, false)
                                                    : // navigate(`/dashboard/rfp/view/${id}`)
                                                    () =>
                                                      CommunityJob ?
                                                        navigate(`/dashboard/official-request/view/${id}`, { state: { fromProjects: true } }) :
                                                        // communityDesignOrder ? navigate(`/dashboard/design-order/view/${id}`) :
                                                        communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) :
                                                          handleOpenDetailsSalesOrder(id, name)
                                                  : () =>
                                                    enqueueSnackbar(
                                                      'Access Denied: You do not have sufficient permissions',
                                                      { variant: 'error' },
                                                    )
                                        }
                                        variant="subtitle1"
                                        sx={{
                                          mt: 3,
                                          mr: 2,
                                          color: theme.palette.primary.main,

                                          '&:hover': {
                                            cursor: CommunityProjects
                                              ? explodedPermissions?.some((permission) =>
                                                [
                                                  'Add Jobs',
                                                  'Edit Jobs',
                                                  'Activate/Deactivate Jobs',
                                                  'Delete Jobs',
                                                  'Manage Job Cost',
                                                ].includes(permission),
                                              )
                                                ? 'pointer'
                                                : 'default'
                                              : quotationView
                                                ? (explodedPermissions?.some((permission) =>
                                                  ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                                ) ||
                                                  (userType === 3 && status !== 6)) &&
                                                  !(userType === 3 && accept_status === 2)
                                                  ? 'pointer'
                                                  : 'default'
                                                : designOrder
                                                  ? (explodedPermissions?.some((permission) =>
                                                    ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                                  ) ||
                                                    (userType === 3 && status !== 6)) &&
                                                    !(userType === 3 && accept_status === 2)
                                                    ? 'pointer'
                                                    : 'default'
                                                  :
                                                  (explodedPermissions?.some((permission) =>
                                                    [
                                                      'Edit Request',
                                                      'View request',
                                                      'Delete request',
                                                      'Add vendor to request',
                                                      'Add client to request',
                                                    ].includes(permission),
                                                  ) ||
                                                    (userType === 3 && status !== 6)) &&
                                                    !(userType === 3 && accept_status === 2)
                                                    ? 'pointer'
                                                    : 'default',
                                          },
                                        }}
                                      >
                                        Details
                                      </Button>
                                    )}
                                  </>
                                  :
                                  <Button onClick={() => {
                                    handleQuotationEditClick(row);
                                  }}>
                                    Details
                                  </Button>

                                }
                              </>
                            </TableCell>
                            :
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>

                              {(userType != 3 && currentTab != "APPROVED" && designOrder) && (status === 1 || status === 6) &&
                                <UserMoreMenu
                                  hold={hold}
                                  {...(currentTab != "APPROVED" && (status === 1 || status === 6) ? {
                                    onHold: () => {
                                      if (explodedPermissions?.some(permission => ['Hold Design Order Jobs'].includes(permission))) {
                                        setOpenHoldPopup(true);
                                      } else {
                                        enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                                      }
                                    }
                                  } : {})}

                                />
                              }
                              <Dialog
                                open={openHoldPopup}
                                onClose={() => {
                                  setOpenHoldPopup(false);
                                  setHoldReason('');
                                }}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                BackdropProps={{ invisible: true }}
                              >
                                <DialogTitle id="alert-dialog-title">
                                  {hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
                                </DialogTitle>
                                <DialogContent>
                                  <DialogContentText id="alert-dialog-description">
                                    {
                                      designOrder ? (
                                        hold === 1
                                          ? 'You want to move this Design Order from Hold.'
                                          : 'You want to move this Design Order to Hold.'
                                      ) : (
                                        hold === 1
                                          ? 'You want to move this Sales Order from Hold.'
                                          : 'You want to move this Sales Order to Hold.'
                                      )
                                    }
                                    {/* {hold === 1
                                                            ? 'You want to move this Design Order from Hold.'
                                                            : 'You want to move this Design Order to Hold.'} */}
                                  </DialogContentText>
                                  {(hold === 0) ? (
                                    <TextField
                                      sx={{ width: 400 }}
                                      label="Reason"
                                      type="text"
                                      multiline
                                      minRows={3}
                                      maxRows={7}
                                      value={holdReason}
                                      onChange={(e) => {
                                        setHoldReason(e.target.value);
                                        if (holdReasonError) setHoldReasonError('');
                                      }}
                                      error={Boolean(holdReasonError)}
                                      helperText={holdReasonError}
                                    />
                                  ) : ''}
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={async () => {
                                      if ((hold === 0) && !holdReason.trim()) {
                                        setHoldReasonError(`Reason is required to put this ${designOrder ? 'Design Order on Hold' : 'Sales Order on Hold'}.`);
                                        return;
                                      }

                                      setIsSubmittingHold(true);
                                      if (designOrder) {
                                        await handleUpdateHoldStatus(holdReason, row?.id);
                                      } else {
                                        await handleUpdateSalesOrderHoldStatus(holdReason, row?.id)
                                      }
                                      setIsSubmittingHold(false);
                                      setOpenHoldPopup(false);
                                      setHoldReason('');
                                      setHoldReasonError('');
                                    }}
                                    disabled={isSubmittingHold}
                                  >
                                    {isSubmittingHold ? (
                                      <CircularProgress size={20} color="inherit" />
                                    ) : (
                                      'OK'
                                    )}
                                  </Button>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => {
                                      setOpenHoldPopup(false);
                                      setHoldReason('');
                                    }}
                                    sx={{ color: theme.palette.error.main }}
                                  >
                                    Cancel
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            </TableCell>
                          }
                        </TableRow>
                      );

                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
  
              {/* <TablePagination
                rowsPerPageOptions={[6, 12, 27, 39]}
                component="div"
                 count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
            </Card>
           
          </Grid>
        
        
      </Grid>
    
             <Modal
                    open={deleteTeam}
                    handleClose={() => {
                      setDeleteTeam(false);
                    }}
                  // modalTitle={'Remove Team Member'}
                  >
                    <FormikProvider value={Formik}>
                      <Form noValidate autoComplete="off">
                        <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                          <Avatar
                            alt={setectedRow?.name}
                            src={setectedRow?.profile_pic ? setectedRow?.profile_pic : setectedRow?.name }
                            sx={{ width: 150, height: 150, margin: "auto", }}
                          />
                          <Typography variant="h5" sx={{ color: 'primary.secondary', alignSelf: 'center' }}>
                            Are you sure you want to delete {setectedRow?.name} ?</Typography>
                        </Stack>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid item xs={12} md={6}>
                            <Box sx={{ my: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                              <Button variant="contained"
                                onClick={() => {
                                  if(fromClient !== true){
                                    setDeleteTeam(false);
                                    changeStatus(deleteId, 2);
                                  // navigate(PATH_DASHBOARD.callCenter.teams, { state: { data: deleteId } });
                                  }else{
                                    handleDeleteClient(deleteId,2)
                                    
                                  }
                                }}>
                                Yes, Delete it!
                              </Button>
                              <Button variant="outlined" onClick={() => {
                                setDeleteTeam(false);
                              }}>
                                No, Cancel pls!
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Form>
                    </FormikProvider>
                  </Modal>
</>
  );
}
